import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TrialInsightsStore } from '@models/trial-insights/trial-insights.store';

import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { MainQuery } from '@shared/store/main/main.query';

import { TrialInsightsFinanceBvaChartMenuComponent } from '../trial-insights-finance-bva-chart-menu/bva-chart-menu.component';
import { TrialInsightsFinanceComparingBudgetComponent } from '../trial-insights-finance-comparing-budget/trial-insights-finance-comparing-budget.component';
import { TrialInsightsFinanceEnrolledPatientsComponent } from '../trial-insights-finance-enrolled-patients/trial-insights-finance-enrolled-patients.component';
import { TrialInsightsFinancePaymentMilestonesComponent } from '../trial-insights-finance-payment-milestones/trial-insights-finance-payment-milestones.component';
import { TrialInsightsFinanceRemainingSpendOverTimeComponent } from '../trial-insights-finance-remaining-spend-over-time/trial-insights-finance-remaining-spend-over-time.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TrialInsightsFinanceBvaChartMenuComponent,
    TrialInsightsFinanceComparingBudgetComponent,
    TrialInsightsFinanceRemainingSpendOverTimeComponent,
    TrialInsightsFinancePaymentMilestonesComponent,
    TrialInsightsFinanceEnrolledPatientsComponent,
    AsyncPipe,
  ],
  styleUrls: ['../../trial-insights.component.scss'],
  templateUrl: './trial-insights-finance.component.html',
})
export class TrialInsightsFinanceComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private launchDarklyService = inject(LaunchDarklyService);
  private mainQuery = inject(MainQuery);
  private trialInsightsStore = inject(TrialInsightsStore);

  componentsLoading = false;
  showInvestigatorSpendCard$: Observable<boolean>;
  trialLoading = false;

  ngOnInit(): void {
    this.mainQuery
      .select('currentOpenMonth')
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((currentOpenMonth) => {
          if (!currentOpenMonth) {
            return;
          }

          this.trialInsightsStore.update((state) => ({
            ...state,
            currentOpenMonth,
          }));
        })
      )
      .subscribe();
  }

  constructor() {
    this.showInvestigatorSpendCard$ = this.launchDarklyService.select$(
      (flags) => flags.finance_dash_remaining_investigator_spend
    );
  }
}
